<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Zmiana nr faktury
  </div>

  <div  fxFlex="100">
    <mat-form-field fxFlex="100">
        <mat-label>Nr faktury który będzie wygenerowany na kolejnej fakturze</mat-label>
        <input     appCapitalizeFirst matInput placeholder="12" [formControl]="invoiceNumberControl">
    </mat-form-field>
  </div>


  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>
    <button *ngIf="!enableEditButton"
      mat-raised-button (click)="edit()"
    >Edytuj</button>
    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
